import { render, staticRenderFns } from "./LevelCreate.vue?vue&type=template&id=439db1fc&scoped=true"
import script from "./LevelCreate.vue?vue&type=script&lang=js"
export * from "./LevelCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439db1fc",
  null
  
)

export default component.exports